
// 
export function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}


export const metaInfo= {
  title: '云安智消-智慧消防整体解决方案合作商',
  meta: [
    {
      name: 'keywords',
      content: '云安智消-智慧消防整体解决方案合作商'
    },
    {
      name: 'description',
      content: '云安智消-智慧消防整体解决方案合作商'
    }
  ]
}




// WEBPACK FOOTER //
// ./src/utils/index.js